import angular from 'angular';
import { VerifyPhoneCodeConfig } from './code.config';
import { VerifyPhoneCodeComponent } from './code.component';
import { VerifyPhoneCodeComponent as UdsVerifyPhoneComponent } from '../../new-design/phone/code/code.component';
import { StepPageModule } from '../../../common/directives';

export const VerifyPhoneCodeModule = angular
  .module('app.verify.phone.code', [StepPageModule.name])
  .config(VerifyPhoneCodeConfig)
  .component('updVerifyPhoneCode', VerifyPhoneCodeComponent)
  .component('udsVerifyPhoneCode', UdsVerifyPhoneComponent);
